// extracted by mini-css-extract-plugin
export default {"container":"rL-z","topReviewHeading":"sL-z","criticalReview":"tL-z","favorableReview":"uL-z","vsSeparator":"vL-z"};